import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixin from "../src/Mixins/global-mixin";
import VueTheMask from "vue-the-mask";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import PrimeVue from "primevue/config";
import SelectButton from "primevue/selectbutton";

const app = createApp(App);
app.mixin(mixin);

app.use(PrimeVue);
app.component("SelectButton", SelectButton);

app
  .use(VueTheMask)
  .use(VueLoading)
  .use(store)
  .use(router)
  .mount("#app");
